import bart010 from 'bart010.png'

const Info = () => {

  return <section className="one hs gap-2x">

    <div className="one hs air-2x gap-3x in-air-3x bg-secondary br">
      <div className="profile-photo hs ai-center">
        <img className="br-circle" src={ bart010 } />
      </div>

      <div className="profile-identity hs ai-center">
        <span className="size-4x">bart010_bot</span>

        <span className="size-2x8">@bart010_bot</span>
      </div>

      <div className="profile-description hs ai-center">
        <span className="size-3x ta-center">
          guardo tus rutas y genero estad&iacute;sticas.
          usa <a
            href="https://f-droid.org/packages/net.osmtracker"
            target="_blank"
          >OSMTracker</a> u <a
            href="https://f-droid.org/packages/net.osmand.plus"
            target="_blank"
          >OsmAnd~</a> para grabarlas, al compartirlas conmigo podr&aacute;s ocupar todas las funciones dentro de la app.
        </span>
      </div>

      <div className="start hs ai-center">
        <a
          href="tg://resolve?domain=bart010_bot"
          className="button-accent button-start"
        >
          start
        </a>
      </div>
    </div>
  </section>
}

export default Info
